import {
  LIFETRAQ_LOGO_URL,
  SCDC_LOGO_URL,
  TRAQIFY_LOGO_URL,
} from "Consts/static";
import { isSCDC } from "Shared/helpers/isSCDC";
import { isTraqify } from "Shared/helpers/isTraqify";

export const parseLogoUrl = () => {
  if (isSCDC()) return SCDC_LOGO_URL;
  if (isTraqify()) return TRAQIFY_LOGO_URL;
  return LIFETRAQ_LOGO_URL;
};
